import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY
const supabase = createClient(supabaseUrl, supabaseKey)

export default class Usuario{
    static async getByNumDocumento(numDocumento) {
        if (!numDocumento && numDocumento !== 0) return { data: null, error: new Error('numDocumento requerido') };
        try {
            const { data, error } = await supabase
                .from('Usuarios')
                .select('nombre, usuario, correo, numTelefono, cantVaritas')
                .eq('numDocumento', numDocumento)
                .single();
            if (!error) return { data, error: null };
            // intento alterno por si el casing difiere
            const alt = await supabase
                .from('Usuarios')
                .select('nombre, usuario, correo, numTelefono, cantVaritas')
                .eq('numdocumento', numDocumento)
                .single();
            if (!alt.error) return { data: alt.data, error: null };
        } catch (e) {
            console.error('[Usuario.getByNumDocumento] excepción:', e);
        }
        return { data: null, error: null };
    }

    static async getCantVaritas(numDocumento) {
        const { data, error } = await this.getByNumDocumento(numDocumento);
        if (error) return { data: 0, error };
        return { data: data?.cantVaritas ?? 0, error: null };
    }
    static async getNumDocumentoPorUsuario(usuario) {
        const { data, error } = await supabase.rpc('getnumdocumento', { _usuario: usuario });
        if (error) return null;
        return data; 
    }

     static async login(numDocumento, contrasenna) {
        const { data, error } = await supabase.rpc('allowLogin', { _user: numDocumento, _passw: contrasenna });
        if (error) return false;
        return data;
    }

    static async register(numDocumento, idTipoUsuario, idTipoDoc, nombre, usuario, correo, contrasenna, numTelefono, direccion, descripcion, cantVaritas, activo){
        const { data, error } = await supabase.rpc('register_usuario', {
            _numdocumento: numDocumento,
            _idtipousuario: idTipoUsuario,
            _idtipodoc: idTipoDoc,
            _nombre: nombre,
            _usuario: usuario,
            _correo: correo,
            _contrasenna: contrasenna,
            _numtelefono: numTelefono,
            _direccion: direccion,
            _descripcion: descripcion,
            _cantvaritas: cantVaritas,
            _activo: activo
        });

        return !error;
    }

    static async agregarVaritas(numDocumento, cantidad){
        const {error} = await supabase.rpc('addVaritas', {_user: numDocumento, _cant: cantidad});
        return !error;
    }

    static async removerVaritas(numDocumento, cantidad){
        const {error} = await supabase.rpc('removeVaritas', {_user: numDocumento, _cant: cantidad});
        return !error;
    }

    static async update(numDocumento, nombre, usuario, correo, contrasenna, numTelefono, direccion, descripcion) {
        const {data, error} = await supabase.rpc('update_usuario', {
            _contrasenna: contrasenna,
            _correo: correo,
            _descripcion: descripcion,
            _direccion: direccion,
            _nombre: nombre,
            _numtelefono: numTelefono,
            _user: numDocumento,
            _usuario: usuario
        });
        if (error) return error;
        return data;
    }

    static async updateState(numDocumento) {
        const {data, error} = await supabase.rpc('updateEstado', { _user: numDocumento });
        if (error) console.log(error);
        return data;
    }

    static async getUsuario(numDocumento) {
        const {data, error} = await supabase.rpc('get_usuario', { _user: numDocumento });
        if (error) console.log(error);
        return data;
    }

    static async getUsers(){
        const {data, error} = await supabase.rpc('getallusers');
        if (error) console.log(error);
        return data;
    }

    static async existsUsuario(usuario){
        try{
            const { data, error } = await supabase
                .from('Usuarios')
                .select('usuario')
                .eq('usuario', usuario)
                .limit(1);
            if (error) { console.warn('[Usuario.existsUsuario] error:', error); return false; }
            return Array.isArray(data) && data.length > 0;
        } catch(e){ console.warn('[Usuario.existsUsuario] excepción:', e); return false; }
    }

    static async existsCorreo(correo){
        try{
            const { data, error } = await supabase
                .from('Usuarios')
                .select('correo')
                .eq('correo', correo)
                .limit(1);
            if (error) { console.warn('[Usuario.existsCorreo] error:', error); return false; }
            return Array.isArray(data) && data.length > 0;
        } catch(e){ console.warn('[Usuario.existsCorreo] excepción:', e); return false; }
    }

    static async isAdmin(numDocumento){
        const {data, error} = await supabase.rpc('isadmin', {_user: numDocumento});
        if (error) console.log(error);
        return data;
    }

    static async comprar(idUser, idProduct){
        const {data, error} = await supabase.rpc('insert_compra', {_user: idUser,_product: idProduct});
        if (error) console.log(error);
        return data;
    }

    static async getProducts(numDocumento){
        const {data, error} = await supabase.rpc('get_all_products', {_user: numDocumento});
        if (error) console.log(error);
        return data;
    }

    static async getResennas(numDocumento){
        const {data, error} = await supabase.rpc('get_resennas', {_user: numDocumento});
        if (error) console.log(error);
        return data;
    }

    static async setResenna(numDocumento, idProducto, valoracion, descripcion){
        const {data, error} = await supabase.rpc('insert_resenna', {_user: numDocumento, _product: idProducto, _val: valoracion, _descripcion: descripcion});
        if (error) console.log(error);
        return data;
    }
}